import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { SourcePDF } from "./SourceDialog";
import { getFile } from "../../../../core/repo/fileRepo";
import Loader from "../../../../components/Loader";

function EntityDialog({ entity, handleEntityChange }) {
  const { file_id } = entity;
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  let source = { page: 0, coordinates: null, section: entity["title"] };

  const fetchFile = async () => {
    try {
      const file = await dispatch(getFile(file_id));
      setFile(file);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (file_id) fetchFile();
  }, [file_id]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        file && (
          <Grid item size={{ md: 8 }} height={"100%"}>
            <SourcePDF
              file={{
                name: file["name"],
                file_url: entity["entity_url"],
              }}
              source={source}
              handleSourceChange={handleEntityChange}
              entity={true}
            />
          </Grid>
        )
      )}
    </>
  );
}

export default EntityDialog;
